import { Fragment, useCallback } from 'react';

import PropTypes from 'prop-types';
import { ChangeHistoryType } from 'utils/constants/admin';

import { MenuItem } from 'bloko/blocks/drop';

import useTrls from 'hooks/translation/useTrls';

import fetchModeration from 'components/BanerAdminActions/MenuItems/fetchModeration';
import { fetchChangeHistoryEvents } from 'components/CampaignAdminActions/MenuItems/fetchChangeHistoryEvents';

import { useDispatch } from 'store/utils';

const MenuItems = ({ campaignId, bannerId, close }) => {
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClick = useCallback(() => {
        dispatch(fetchModeration(campaignId, bannerId));
        close();
    }, [bannerId, campaignId, close, dispatch]);
    const onClickChangeHistory = useCallback(() => {
        dispatch(fetchChangeHistoryEvents(ChangeHistoryType.Banner, campaignId, bannerId));
        close();
    }, [bannerId, campaignId, close, dispatch]);
    return (
        <Fragment>
            <MenuItem onClick={onClick}>{trl('banner.actions.sudo.actions.moderation')}</MenuItem>
            <MenuItem onClick={onClickChangeHistory}>{trl('campaign.info.sudo.actions.changeHistory')}</MenuItem>
        </Fragment>
    );
};

MenuItems.propTypes = {
    campaignId: PropTypes.number,
    bannerId: PropTypes.number,
    close: PropTypes.func,
};

export default MenuItems;
